/**
 * The QC Batch form's Created By. A new batch shows the signed-in user, who the API
 * records as its creator when it saves. A saved batch shows only its own creator, so
 * one with none on record reads blank rather than naming whoever opened it.
 */
export function qcBatchCreatedBy(isSavedBatch: boolean, savedCreator: string | null | undefined, currentUser: string): string {
  return isSavedBatch ? savedCreator ?? '' : currentUser;
}
